<template>
	<div>
		<header>
			<h1 class="alpha heavy">Create User</h1>
		</header>
		<div>
			<div class="sections">
				<div class="section--floating section--full">
					<user-form cta="Create User"/>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import UserForm from "./forms/UserForm.vue";

export default {
	components: {
		UserForm,
	},
};
</script>
